/**
 * {@code user_status} query values for Connect25 User Search (tile API).
 * Mirrors {@code com.collegenet.series25.document.studentengagement.StudentEngagementUserLoginStatus} on the server.
 */
export enum StudentEngagementUserLoginStatusQueryValue {
    Active = "active",
    NoLogin = "no_login",
    LoginDisabled = "login_disabled",
}

/** ngModel / UI: empty string means all statuses. */
export type StudentEngagementUserSearchStatusFilterModel = "" | StudentEngagementUserLoginStatusQueryValue;

export function parseStudentEngagementUserSearchStatusFilter(
    raw: string,
): StudentEngagementUserLoginStatusQueryValue | undefined {
    const trimmed = raw.trim();
    if (trimmed === "") {
        return undefined;
    }
    for (const value of Object.values(StudentEngagementUserLoginStatusQueryValue)) {
        if (value === trimmed) {
            return value;
        }
    }
    return undefined;
}
